// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmSubmitController from "./confirm_submit_controller"
application.register("confirm-submit", ConfirmSubmitController)

import CustomDurationController from "./custom_duration_controller"
application.register("custom-duration", CustomDurationController)

import DataTableController from "./data_table_controller"
application.register("data-table", DataTableController)

import DisableCollapsedInputsController from "./disable_collapsed_inputs_controller"
application.register("disable-collapsed-inputs", DisableCollapsedInputsController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import OffcanvasLinkController from "./offcanvas_link_controller"
application.register("offcanvas-link", OffcanvasLinkController)

import PersistentTabsController from "./persistent_tabs_controller"
application.register("persistent-tabs", PersistentTabsController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StickyHeaderController from "./sticky_header_controller"
application.register("sticky-header", StickyHeaderController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleButtonController from "./toggle_button_controller"
application.register("toggle-button", ToggleButtonController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
